module.exports = __webpack_public_path__ + "img/cyber-car00.91f61eda.gif";